/**
 * The compact relative time a conversation row shows on its right edge: `now`, `12m`, `2h`,
 * `Yesterday`, `Aug 25`.
 *
 * A terser vocabulary than `formatSmartDate` ("just now", "12m ago", "Feb 13, 2026") on
 * purpose — the flyout is 340px wide and the panel narrower still, so the time column has to
 * survive next to a title and a mark. The design names these exact strings.
 *
 * Takes `now` as an argument rather than reading the clock, so a re-render is driven by a
 * clock the surface owns and a test can state a duration instead of approximating one.
 */
export function formatConversationTime(timestamp: number, now: number): string {
  const minutes = Math.floor((now - timestamp) / 60_000);

  if (minutes < 1) return "now";
  if (minutes < 60) return `${minutes}m`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;

  const date = new Date(timestamp);
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (date.toDateString() === yesterday.toDateString()) return "Yesterday";

  const nowDate = new Date(now);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    ...(date.getFullYear() === nowDate.getFullYear() ? {} : { year: "numeric" }),
  });
}
